<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl'] ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_items") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div class="px-6 py-4">
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
            <div class="flex">
              <div class="w-full">
                <BaseInput
                  v-model="i_id"
                  type="text"
                  :label="$t('item_barcode')"
                  :placeholder="$t('item_barcode')"
                  :rules="rules"
                  :isError="checkRulesIsError(i_id, 'add', this.rules).isError"
                  :errorMsg="
                    checkRulesIsError(i_id, 'add', this.rules).errorMsg
                  "
                />
              </div>
              <div class="w-2" v-if="linkDrop !== ''"></div>

              <div
                class="cursor-pointer w-2/12 lg:w-1/12 text-white text-2xl bg-primaryColor p-1 my-8 rounded-lg hover:shadow-md text-center"
              
                @click="generateBarcode"
              >
                #
              </div>
            </div>
            <BaseInput
              v-model="i_name"
              :label="$t('item_name')"
              :placeholder="$t('item_name')"
              :rules="rules"
              :isError="checkRulesIsError(i_name, 'add', this.rules).isError"
              :errorMsg="checkRulesIsError(i_name, 'add', this.rules).errorMsg"
            />
            <BaseInput
              v-model="i_name_ar"
              :label="$t('item_name_ar')"
              :placeholder="$t('item_name_ar_optional')"
              :rules="no_rule"
              :isError="checkRulesIsError(i_name_ar, 'add', this.no_rule).isError"
              :errorMsg="checkRulesIsError(i_name_ar, 'add', this.no_rule).errorMsg"
            /><DropdownInput
              v-model="ca_id"
              :placeholder="$t('choose_item_category')"
              :label="$t('item_category')"
              :items="convertToListIdValueCategory"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(ca_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(ca_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/item-category"
            /><DropdownInput
              v-model="un_id"
              :label="$t('item_unit')"
              :items="convertToListIdValueUnits"
              :placeholder="$t('choose_item_unit')"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(un_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(un_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/item-unit"
            />

            <BaseInput
              v-model="i_sale_price"
              type="number"
              :label="$t('sale_price')"
              :placeholder="$t('sale_price')"
              :rules="rules"
              :isError="
                checkRulesIsError(i_sale_price, 'add', this.rules).isError
              "
              :errorMsg="
                checkRulesIsError(i_sale_price, 'add', this.rules).errorMsg
              "
            />
            <BaseInput
              v-model="i_package"
              type="number"
              :label="$t('carton_size')"
              :placeholder="$t('carton_size')"
              :rules="no_rule"
            />
            <BaseInput
              v-model="i_package_price"
              type="number"
              :label="$t('carton_price')"
              :placeholder="$t('carton_price')"
              :rules="no_rule"
            />
            <p class="text-xs text-gray-500 dark:text-gray-400 md:col-span-2 -mt-2">
              {{ $t("carton_example_helper") }}
            </p>
            <DropdownInput
              v-model="cur_id"
              :label="$t('currency_type')"
              :items="convertToListIdValue"
              :placeholder="$t('choose_currency_type')"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).errorMsg
              "
            />
            <FileInput
              :key="fileInputKey"
              :label="$t('item_photo')"
              :placeholder="$t('choose_item_photo')"
              @change="onChange"
            />
            <TextAreaInput
              v-model="i_desc"
              :label="$t('item_description')"
              :placeholder="$t('item_description')"
              :rules="no_rule"
              :isError="checkRulesIsError(i_desc, 'add', this.no_rule).isError"
              :errorMsg="
                checkRulesIsError(i_desc, 'add', this.no_rule).errorMsg
              "
            />
          </div>

          <!-- Package Pricing Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {{ $t("package_pricing") }}
            </h3>
            <div class="space-y-4 w-full md:w-1/2">
              <div
                v-for="(pkg, index) in i_packages"
                :key="index"
                class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <div class="flex-1">
                  <BaseInput
                    v-model="pkg.name"
                    :label="$t('package_name')"
                    :placeholder="$t('package_name')"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="pkg.quantity"
                    type="number"
                    :label="$t('package_quantity')"
                    :placeholder="$t('package_quantity')"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="pkg.price"
                    type="number"
                    :label="$t('package_price')"
                    :placeholder="$t('package_price')"
                    :rules="no_rule"
                  />
                </div>
                <button
                  type="button"
                  @click="removePackage(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addPackage"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_package") }}
              </button>
            </div>
          </div>

          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import { formatDate } from "../../utils/functions";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { CURRENCYS } from "../../constants/config";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
//import Compressor from "compressorjs";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ResultDialog,
    TextAreaInput,
    DropdownInput,
    FileInput,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      isSubmited: false,
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      currencys: CURRENCYS,
      ca_id: "",
      un_id: "",
      i_desc: "",
      i_name: "",
      i_name_ar: "",

      i_expire_date: "",
      i_image: "",
      i_quantity: "",
      i_id: "",
      i_sale_price: "",
      i_package: "",
      i_package_price: "",
      cur_id: 2,
      compressedImage: null,
      i_packages: [],
      fileInputKey: 0,
    };
  },
  created() {
    this.$store.dispatch("item_category/getCategory");
    this.$store.dispatch("item_unit/getUnits");
  },

  computed: {
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isBtnLoading() {
      return this.$store.state.add_item.isBtnLoading;
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueUnits() {
      var boxes = this.$store.state.item_unit.units;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.un_id,
          value: item.un_name,
        });
      }

      return list;
    },

    convertToListIdValueCategory() {
      var categorys = this.$store.state.item_category.categorys;
      var list = [];
      for (const item of categorys) {
        list.push({
          id: item.ca_id,
          value: item.ca_name,
        });
      }

      return list;
    },
  },

  methods: {generateBarcode() {
      //generate random 10 digit barcode
      this.i_id = Math.floor(
        1000000000 + Math.random() * 9000000000
      ).toString();
    },
    formatDate(date) {
      return formatDate(date);
    },

    async addSaleItem(e) {
      e.preventDefault();
      //check form validation
      if (this.$store.state.add_item.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.ca_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.un_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.i_name, "add", this.rules).isError ||
        this.checkRulesIsError(this.i_sale_price, "add", this.rules).isError ||
        this.checkRulesIsError(this.cur_id, "add", this.rules).isError
      ) {
        return;
      }
      const packageSize = Number(this.i_package || 0);
      const packagePrice = Number(this.i_package_price || 0);
      if (packageSize < 0 || packagePrice < 0) {
        return;
      }
      if (packagePrice > 0 && packageSize <= 0) {
        alert(this.$t("carton_size_required_if_carton_price_exists"));
        return;
      }
      if (packageSize > 0 && packagePrice <= 0) {
        alert(this.$t("carton_price_required_if_carton_size_exists"));
        return;
      }
      
      // Validate packages: each package must have a name
      if (this.i_packages.length > 0) {
        for (let i = 0; i < this.i_packages.length; i++) {
          if (!this.i_packages[i].name || this.i_packages[i].name.trim() === '') {
            alert(this.$t('package_name_required') || 'Package name is required for all packages');
            return;
          }
        }
      }
  
      this.$store.state.add_item.isBtnLoading = true;
      var res = await this.$store.dispatch("add_item/addNewItem", {
        ca_id: this.ca_id,
        un_id: this.un_id,
        i_desc: this.i_desc,
        i_name: this.i_name,
        i_name_ar: this.i_name_ar,
        i_sale_price: this.i_sale_price,
        i_package: this.i_package === "" || this.i_package === null ? null : this.i_package,
        i_package_price: this.i_package_price === "" || this.i_package_price === null ? null : this.i_package_price,
        cur_id: this.cur_id,
        

        i_expire_date: this.i_expire_date,
        file: this.i_image,
        i_quantity: this.i_quantity,
        i_id: this.i_id,
        i_packages: this.i_packages,
      });
      if (res.status == 200) {
        this.i_desc = "";
        this.i_name = "";
        this.i_name_ar = "";
        this.i_expire_date = "";
        this.i_image = "";
   
        this.i_quantity = "";
        this.ca_id = "";
        this.$store.state.add_item.isBtnLoading = false;
        this.i_id = "";
        this.i_sale_price = "";
        this.i_package = "";
        this.i_package_price = "";
        this.i_packages = [];
        //make the image impty
        this.i_image = "";
        this.compressedImage = null;
        this.fileInputKey += 1;

        this.isSubmited = false;
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    onChange(files) {
      this.i_image = files[0] || null;
    },
    compressImage() {
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // Set the canvas dimensions to the image dimensions
          canvas.width = img.width;
          canvas.height = img.height;

          // Draw the image on the canvas
          ctx.drawImage(img, 0, 0);

          // Get the compressed data URL
          const compressedDataURL = canvas.toDataURL("image/jpeg", 0.7);

          // Set the compressed image
          this.compressedImage = compressedDataURL;
        };
      };

      reader.readAsDataURL(this.i_image);
    },
    addPackage() {
      this.i_packages.push({
        name: "",
        quantity: 1,
        price: 0,
      });
    },
    removePackage(index) {
      this.i_packages.splice(index, 1);
    },
  },
};
</script>
<style>
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(40%) sepia(96%) saturate(694%) hue-rotate(195deg)
    brightness(85%) contrast(88%);
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
</style>
